import {createReducer} from 'redux-create-reducer';
import {Keys, Actions} from '../constants';
import {standardLoadingReducerFactory} from './reducer-utils';

export default createReducer(
    {},
    standardLoadingReducerFactory(
        Actions.GET_GROUPS,
        Keys.StoreSliceData.GROUPS
    )
);



// WEBPACK FOOTER //
// ./src/model/reducers/groups-reducer.js